export default {
      id: "eta-track-usage",
      viewBox: "0 0 27 27",
      url: __webpack_public_path__ + "img/icons.svg#eta-track",
      toString: function () {
        return this.url;
      }
    }